<template>
  <DefaultLayout :disableFacilitatorTools="true">
      <h5>{{ $t("linktogame") }} {{ gameName }}</h5>

      <PlayerObserverLinks :gameCode="gameCode" :showObserverLink="$store.state.main.userViewObserverLink" />

      <base-button type="primary" @click="close()">{{
        $t("close")
      }}</base-button>
  </DefaultLayout>
</template>

<script>
import PlayerObserverLinks from "@/components/PlayerObserverLinks.vue";
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import {
  getGameByGameCode,
} from "@/services/APIService";

export default {
  data() {
    return {
      gameCode: null,
      gameName: "",
    };
  },
  components: { PlayerObserverLinks, DefaultLayout, },
  computed: {},
  methods: {
    close() {
      this.$router.push("/admin/games");
    },
    getUrl() {
      return window.location.origin + "/gamecode/" + this.gameCode;
    },
    getObserverUrl() {
      return window.location.origin + "/observe/gamecode/" + this.gameCode;
    }
  },
  created() {
    this.gameCode = this.$route.params.gamecode;
    getGameByGameCode(this.gameCode).then((resp) => {
        this.gameName = resp.name;
    });
  }
};
</script>

<i18n>
{
"en": {
    "linktogame": "Links to simulation",
    "close": "Close"
  },
  "fi": {
    "linktogame": "Linkit simulaatioon",
    "close": "Sulje"
  },
"sv": {
    "linktogame": "Länkar till simulering",
    "close": "Stäng"
  },
"de": {
    "linktogame": "Links zur Simulation",
    "close": "Schließen"
  },
"ko": {
    "linktogame": "시뮬레이션 링크",
    "close": "닫기"
  }
}
</i18n>
